<div class="container">
    <div class="row">
        <div class="card" style="width: 100%">
            <div class="card-body px-0">
                @if (appealStatusTrackerSwitch && !isPartner) {
                <nav class="d-lg-block" [attr.aria-label]="'SUBMISSION_STATUS_NAVIGATION' | globalTranslate">
                    <ul class="nav nav-tabs nav-justified nav-fill flex-lg-row tab-height">
                        <li class="nav-item item-height">
                            <a class="nav-link d-flex flex-row justify-content-center p-0 link-height" routerLinkActive="active" [routerLink]="['submissions']">
                                <span class="tab-section">{{ 'APPLICATION_STATUS_TAB' | globalTranslate }}</span>
                            </a>
                        </li>
                        <li class="nav-item item-height">
                            <a class="nav-link d-flex flex-row justify-content-center p-0 link-height" routerLinkActive="active" [routerLink]="['appeals']" (click)="trackAppealsTabClick()">
                                <span class="tab-section">{{ 'APPEALS_TAB' | globalTranslate }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>
                }
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>